import { type GetRequestData, getRequest } from './getRequest';

/**
 * throw the error to be caught by the outer try-catch
 */

export const downloadFile = async (
  fileId: string,
  fileExtension: string,
  fileName?: string,
): Promise<void> => {
  try {
    const getRequestData: GetRequestData = {
      url: `/files/${fileId}`,
      responseType: 'blob',
    };
    const response = await getRequest(getRequestData);
    const filePre = (fileName ?? '') ? fileName : fileId;

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filePre}.${fileExtension}`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    throw new Error(error);
  }
};
